import { patchState, signalStore, withComputed, withMethods, withState } from '@ngrx/signals';
import { computed } from '@angular/core';
import { AdminUserData } from '../models/user.model';

type AuthState = {
  user: AdminUserData | null;
  loading: boolean;
};

const initialState: AuthState = {
  user: null,
  loading: false,
};

export const AuthStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withComputed(({ user }) => ({
    isAuthenticated: computed(() => user() !== null),
  })),
  withMethods((store) => ({
    setUser(user: AdminUserData | null): void {
      patchState(store, { user });
    },
    setLoading(loading: boolean): void {
      patchState(store, { loading });
    },
    clearUser(): void {
      patchState(store, { user: null });
    }
  }))
);
